import { debounce } from '@/utils/debounce.js';
import { fetcher } from '@/utils/fetcher.js';
//import { mockupData } from '../../utils/mockups.js';
import { BaseClass } from '/src/components/BaseClass.js';
import '@/components/reusable/modal/index.js';
import '@/components/reusable/RChecklist/index.js';
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  :host {
    color: white;
  }

  .search-input {
    margin-bottom: 20px;
  }

  .added-items {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
  }
  
  .input-like {
    width: 100%;
    background-color: var(--color-content-block);
    border: 3px solid var(--color-toolbar);
  }

  .top-level-item {
    padding: 10px;
    border-radius: 4px;
    background-color: var(--color-content-block);
  }

  .content {
    display: flex;
    flex-direction: column;
  }

  .toggle {
    display: flex;
    justify-content: flex-start;
  }

  .checklist {
    overflow: auto;
    flex-grow: 1;
    min-height: 0;
  }

  button {
    font-size: inherit;
    color: white;
  }
`);
export class NSelect extends BaseClass {
    static observedAttributes = ['options'];
    constructor() {
        super();
        this.shadowRoot.adoptedStyleSheets.push(stylesheet);
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'options') {
            this.options = newVal.split('|').map(i => {
                const [id, title] = i.split(':');
                return { id, title };
            });
        }
    }
    connectedCallback() {
        const searchPart = this.#getSearchPart();
        this.shadowRoot.innerHTML = `
        <div class="intro" part="intro">
            <button class="input-like toggle">Выберите...</button>
            <div class="added-items"></div>
        </div>


      <r-modal
        class="modal"
        title="${this.getAttribute('modal-title')}"
        ${this.getAttribute('query') ? `query="${this.getAttribute('query')}"` : ''}
      >
        <div class="content">
          ${searchPart}
          <r-checklist
            class="checklist"
            ${this.hasAttribute('multiple') ? 'multiple' : ''}
          ></r-checklist>
        </div>

        <div class="pair-buttons-container" slot="footer">
          <button class="primary apply" data-close-trigger>Применить</button>
          <button class="secondary" data-close-trigger>Отмена</button>
        </div>
      </r-modal>
    `;
        this.#processClick();
        this.#processInput();
        this.#processApplyClick();
        this.#renderExternalOptions();
    }
    open() {
        this.shadowRoot.querySelector('.checklist').value = this.#selectedOptions.map(({ id }) => id);
        this.shadowRoot.querySelector('.modal').open();
    }
    get value() {
        const v = this.shadowRoot.querySelector('.checklist').value;
        return this.hasAttribute('multiple') ? v.map(({ id }) => id) : v[0].id;
    }
    set value(value) {
        this.#selectedOptions = this.options.filter(({ id }) => this.hasAttribute('multiple') ? value.includes(id) : value === id);
    }
    #search = debounce(async (searchText) => {
        // TODO разблокировать по готовности
        // const data = await fetcher(this.getAttribute('url'), {
        //    params: {
        //      searchText,
        //    }
        //  }).then(r => r.json());
        const items = await Promise.resolve(mockupData((index) => ({ id: index, title: `Какое-то название тега ${index}` }), { limit: 100 }));
        this.shadowRoot.querySelector('.checklist').options = items;
    });
    #selectedOptions = [];
    #getSearchPart() {
        return this.getAttribute('url') ? '<input type="search" class="search-input">' : '';
    }
    #onApply() {
        this.#selectedOptions = this.shadowRoot.querySelector('.checklist').value;
        if (this.hasAttribute('multiple'))
            this.#renderIntroItems();
        else
            this.#renderSingleOption();
        this.dispatchEvent(new CustomEvent('change'));
    }
    /** @param {InputEvent} event */
    #onInput(event) {
        if (!event.target.value) {
            this.shadowRoot.querySelector('.checklist').options = [];
            return;
        }
        this.#search(event.target.value);
    }
    #onToggle() {
        this.open();
    }
    #processApplyClick() {
        this.shadowRoot.querySelector('.apply').addEventListener('click', this.#onApply.bind(this));
    }
    #processClick() {
        this.shadowRoot.querySelector('.toggle').addEventListener('click', this.#onToggle.bind(this));
    }
    #processInput() {
        if (!this.getAttribute('url'))
            return;
        this.shadowRoot.querySelector('.search-input').addEventListener('input', this.#onInput.bind(this));
    }
    #renderExternalOptions() {
        const optionsAttr = this.getAttribute('options');
        if (!optionsAttr)
            return;
        const opts = optionsAttr.split('|').map(i => {
            const [id, title] = i.split(':');
            return { id, title };
        });
        this.shadowRoot.querySelector('.checklist').options = opts;
    }
    #renderIntroItems() {
        const $addedItems = this.shadowRoot.querySelector('.added-items');
        $addedItems.innerHTML = '';
        this.shadowRoot.querySelector('.checklist').value.forEach(i => {
            const $el = document.createElement('div');
            $el.classList.add('top-level-item');
            $el.innerText = i.title;
            $el['data-id'] = i.id;
            $addedItems.append($el);
        });
    }
    #renderSingleOption() {
        this.shadowRoot.querySelector('.toggle').innerText = this.shadowRoot.querySelector('.checklist').value[0].title;
    }
}
customElements.define('n-select', NSelect);
